/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentType,
  PaymentTypeOptional,
  PaymentTypeMetaI,
  PaymentTypeTrackedI,
} from "./payment-type";
import { PaymentTypeTracked, PaymentTypeMeta } from "./payment-type";

/**
 *
 * @export
 * @interface PaymentTypeAmountDTO
 */
export interface PaymentTypeAmountDTOOptional {
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentTypeAmountDTO
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {number}
   * @memberof PaymentTypeAmountDTO
   */
  amount?: number;
}

export interface PaymentTypeAmountDTO extends PaymentTypeAmountDTOOptional {
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentTypeAmountDTO
   */
  paymentType: PaymentType;
  /**
   *
   * @type {number}
   * @memberof PaymentTypeAmountDTO
   */
  amount: number;
}

export interface PaymentTypeAmountDTOTrackedI {
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentTypeAmountDTO
   */
  paymentType?: PaymentType;
  paymentTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentTypeAmountDTO
   */
  amount?: number;
  amountIsSet: boolean;
}

transformDatesMap.set(
  "PaymentTypeAmountDTO",
  function (model: PaymentTypeAmountDTO) {},
);

export type PaymentTypeAmountDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  paymentType: PropertyMeta<PaymentTypeMetaI>;
  //isDate: false
  //isDatetime: false
  amount: PropertyMeta<MetaTypeBase<number>>;
}>;

export var PaymentTypeAmountDTOMeta: PaymentTypeAmountDTOMetaI =
  {} as PaymentTypeAmountDTOMetaI;
PaymentTypeAmountDTOMeta = typeMeta("PaymentTypeAmountDTO", {
  paymentType: propertyMeta("paymentType", false, true, false, PaymentTypeMeta),
  amount: propertyMeta("amount", false, true, false, MetaTypesBase.number),
});

const metaI = PaymentTypeAmountDTOMeta;

registerMeta(() => {});

export class PaymentTypeAmountDTOTracked implements PaymentTypeAmountDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  paymentType__I?: PaymentType = undefined;
  paymentTypeIsSet: boolean = false;
  set paymentType(v: undefined | PaymentType) {
    if (v !== undefined) {
      this.paymentType__I = v;
      this.paymentTypeIsSet = true;
    } else {
      this.paymentType__I = v || undefined;
      this.paymentTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentType() {
    return this.paymentType__I;
  }
  amount__I?: number = undefined;
  amountIsSet: boolean = false;
  set amount(v: undefined | number) {
    if (v !== undefined) {
      this.amount__I = v;
      this.amountIsSet = true;
    } else {
      this.amount__I = v || undefined;
      this.amountIsSet = true;
    }
    this.changeTracker = true;
  }
  get amount() {
    return this.amount__I;
  }
  constructor(config?: PaymentTypeAmountDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PaymentTypeAmountDTOOptional,
    options?: AssignOptions,
  ): PaymentTypeAmountDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.paymentType &&
      this.paymentTypeApplyFilter(optionsRequired.filter)
    ) {
      this.paymentType = config.paymentType;
      if (optionsRequired.unassign) this.paymentTypeIsSet = false;
      else this.paymentTypeIsSet = true;
    }
    if (config.amount && this.amountApplyFilter(optionsRequired.filter)) {
      this.amount = config.amount;
      if (optionsRequired.unassign) this.amountIsSet = false;
      else this.amountIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PaymentTypeAmountDTOTrackedI {
    const cloned = {} as PaymentTypeAmountDTOTrackedI;
    if (
      this.paymentTypeIsSetDeep() &&
      this.paymentTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeIsSet = true;
      cloned.paymentType = this.paymentType;
    } else {
      //cloned.paymentTypeIsSet = false
    }
    if (
      this.amountIsSetDeep() &&
      this.amountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountIsSet = true;
      cloned.amount = this.amount;
    } else {
      //cloned.amountIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PaymentTypeAmountDTOTrackedI {
    if (!this.paymentTypeApplyFilter(filter)) this.paymentTypeIsSet = false;

    if (!this.amountApplyFilter(filter)) this.amountIsSet = false;

    return this;
  }
  paymentTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentTypeAmountDTOMeta.paymentType,
      PaymentTypeAmountDTOMeta,
      this.paymentType,
      this,
    );
  }
  paymentTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeIsSet && this.paymentTypeApplyFilter(filter))
      return true;

    return false;
  }
  amountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentTypeAmountDTOMeta.amount,
      PaymentTypeAmountDTOMeta,
      this.amount,
      this,
    );
  }
  amountIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountIsSet && this.amountApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.paymentTypeIsSetDeep(filter)) return true;
    if (this.amountIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
